import React from 'react';
import {useMutation} from '@tanstack/react-query';
import {Button} from '@heroui/react';
import {request} from '../../lib/request';
import {getErrorMessage, toastError, toastSuccess} from '../../lib/toast';

const CancelDelivery = ({id, refetch, revertStatus, buttonColor}) => {
    const {mutate, isPending} = useMutation({
        mutationFn: async (data) =>
            await request({
                url: '/restaurant/order/complete',
                method: 'post',
                data,
            }),
        onSuccess: (data) => {
            toastSuccess(data.message);
            refetch();
        },
        onError: (error) => {
            toastError(getErrorMessage(error));
        },
    });

    const handleCancel = () => {
        mutate({status: revertStatus, order_id: id});
    };

    return (
        <>
            <Button
                isDisabled
                type="button"
                className={`${buttonColor} rounded-lg font-medium opacity-80 cursor-not-allowed`}
            >
                ارسال شد
            </Button>
            <Button
                isLoading={isPending}
                type="button"
                onPress={handleCancel}
                className="rounded-lg font-medium border-2 border-red-500 bg-white text-red-600 hover:bg-red-50 min-w-[5rem]"
            >
                لغو
            </Button>
        </>
    );
};

export default CancelDelivery;
